<div class="sidebar-xs sidebar-mobile-secondary">
    <div class="page-container" appFullHeight>
        <div class="page-content" [ngClass]="{'has-controls': showControl}">
            <div class="navbar navbar-default navbar-static-top header-highlight" *ngIf="isLoggedIn">
                <div class="navbar-header">
                    <a class="navbar-brand hidden-xs" (click)="navigatePage('map')"></a>
                    <ul class="nav navbar-nav pull-left visible-xs-block mobile-nav">
                        <li><a ui-sref="app.map" ui-sref-active="active" (click)="navigatePage('map')">Map</a></li>
                        <li><a ui-sref="app.fleet" ui-sref-active="active" (click)="navigatePage('fleet')">Fleet</a></li>
                        <li><a ui-sref="app.trip" ui-sref-active="active" (click)="navigatePage('trip')">Trip</a></li>
                        <li><a ui-sref="app.report" ui-sref-active="active" (click)="navigatePage('report')">Report</a></li>
                    </ul>
                    <ul class="nav navbar-nav pull-right visible-xs-block">
                        <li><a ui-sref-active="active" (click)="logout()"><i class="fa fa-sign-out"></i></a></li>
                    </ul>
                </div>
            </div>
			<app-sidebar class="sidebar sidebar-main sidebar-custom" *ngIf="isLoggedIn"></app-sidebar>
			<app-fleet-list class="sidebar sidebar-secondary sidebar-default sidebar-custom" *ngIf="isLoggedIn && (currentRoute == '/map' || currentRoute == '/trip')"></app-fleet-list>
			<div class="content-wrapper">
				<router-outlet></router-outlet>
			</div>
			<app-right-counter class="sidebar sidebar-third" *ngIf="isLoggedIn"></app-right-counter>
            <!--<div class="sidebar sidebar-secondary sidebar-default" ng-include="'assets/templates/partials/fleet-list.html'" ng-class="{'has-follow': $root.followVehicle, 'group-blank': !$root.vehicleFilter}">
            </div>-->            
        </div>
    </div>
</div>
<div class="modal fade" tabindex="-1" role="dialog" id="masterAccount" scrollableModal>
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header pb-0">
                <h4 class="modal-title">Choose an account:</h4>
            </div>
            <div class="modal-body pt-1">
                <div class="row mb-4">
                    <div class="col-md-3" *ngFor="let supername of supernames">
                        <button class="btn btn-lg btn-block btn-primary" (click)="loginWithId(supername)" title="{{supername}}" [disabled]="isSubmitting">
                            {{supername}}
                        </button>
                        <br>
                    </div>
                    <div class="col-md-3">
                        <button class="btn btn-lg btn-block btn-danger" (click)="logout()">
                            Logout
                        </button>
                    </div>
                </div>
                <div class="row">
                    <h4 class="modal-title">OR search by plate number:</h4>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="col-md-10 px-0">
                            <input type="search" class="form-control" (keydown.enter)="searchVehicle()" [(ngModel)]="vehiclePlate" placeholder="Search" name="search">
                            <p *ngIf="resultNull"><span class="smaller text-danger">No vehicle found</span></p>
                            <p *ngIf="resultFound"><span class="smaller">Vehicle found. Logging in ..</span></p>
                        </div>
                        <div class="col-md-2 px-0">
                            <button class="btn clickable" (click)="searchVehicle()" [disabled]="isSubmitting">
                                <i class="icon-search4 text-size-base text-muted v-text-bottom"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" id="masterAccountBackdrop"></div>